import { createElement, forwardRef } from 'react'

import { splitProps } from '../helpers.mjs';
import { getMobileContainerStyle } from '../patterns/mobile-container.mjs';
import { styled } from './factory.mjs';

export const MobileContainer = /* @__PURE__ */ forwardRef(function MobileContainer(props, ref) {
  const [patternProps, restProps] = splitProps(props, [])

const styleProps = getMobileContainerStyle(patternProps)
const mergedProps = { ref, ...styleProps, ...restProps }

return createElement(styled.div, mergedProps)
  })